export default __webpack_public_path__ + "static/media/lupi.789cf8df.png";